var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.obj_to_null(this.product)
    ? _c(
        "div",
        { staticClass: "prod_info" },
        [
          _c("info_field", {
            attrs: {
              f_uniq: "cprice",
              f_title: _vm.__t("PRICE"),
              f_type: "price",
              is_disabled: _vm.is_disabled,
              f_icon: "fa-sack-dollar",
              f_val: _vm.product.price.toString(),
            },
            on: { update_categ: _vm.change_atr },
          }),
          _vm._v(" "),
          _c("info_field", {
            attrs: {
              f_uniq: "cinprice",
              f_title: _vm.__t("MIN_QUAL"),
              f_icon: "fa-sack-dollar",
              f_val: _vm.product.min_qual.toString(),
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }